import button from "./Button";
import VoucherContabil from "./VoucherContabil";
import VCInput from "./Input";
import MaterialIcon from "./MaterialIcon";
import VcCheckbox from "./Checkbox";
import VCTutorial from "./Tutorial";
import vcBannerAviso from "./Banner";
import VCBannerContabil from "./BannerContabil";
import vcBannerAvisoFila from "./BannerAvisoFila";
import VCSpinner from "./Spinner";
import VCBagde from "./Bagde";
import VCBannerBwa from "./BannerBwa";
import VCBannerPadrao from "./BannerPadrao";
import VCBannerFinanceiro from "./BannerFinanceiro";
import VCBannerEduca from "./BannerEduca";
import VCCalloutPlanoDeConta from "./CalloutPlanoDeConta";
import VCBannerAvisoFinanceiro from "./BannerAvisoFinanceiro";
import VCPagination from "./paginacao";
import VCPesquisaDrawer from "./PesquisaDrawer";
import ContratoPendente from "./ContratoPendente";
import VCBannerInsightIA from "./BannerInsightIA";

export type Register = {
  register: () => void;
};

export const components = [
  button,
  VoucherContabil,
  MaterialIcon,
  VCInput,
  VcCheckbox,
  VCTutorial,
  vcBannerAviso,
  vcBannerAvisoFila,
  VCBannerContabil,
  VCSpinner,
  VCBagde,
  VCBannerBwa,
  VCBannerPadrao,
  VCBannerFinanceiro,
  VCBannerEduca,
  VCCalloutPlanoDeConta,
  VCBannerAvisoFinanceiro,
  VCPagination,
  VCPesquisaDrawer,
  VCBannerInsightIA,
  ContratoPendente
] as Register[];
